import { render, staticRenderFns } from "./unclaimed-task.vue?vue&type=template&id=0603fd9e&scoped=true&"
import script from "./unclaimed-task.vue?vue&type=script&lang=js&"
export * from "./unclaimed-task.vue?vue&type=script&lang=js&"
import style0 from "./unclaimed-task.vue?vue&type=style&index=0&id=0603fd9e&lang=less&scoped=true&"
import style1 from "./unclaimed-task.vue?vue&type=style&index=1&id=0603fd9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0603fd9e",
  null
  
)

export default component.exports